export const numericInput = {
  texts: {
    valueIsRequired: 'Este necesară o valoare',
    validNumberIsRequired: 'Este necesar un număr valid'
  }
}
